export const mapResourcesCapabilities = (config) => (
  config.map((capability) => {
    const mapped = {};
    mapped.id = capability.moduleName.toLowerCase();
    switch (mapped.id) {
      case 'faqs': {
        mapped.route = '/faqs';
        mapped.hamburgerMenuSortOrder = 1;
        mapped.DesktopMenuSortOrder = 2;
        mapped.isHamburgerMenuItem = true;
        mapped.isDesktopMenuItem = true;
        break;
      }
      case 'usefullinks': {
        mapped.route = '/useful-links';
        mapped.hamburgerMenuSortOrder = 2;
        mapped.DesktopMenuSortOrder = 3;
        mapped.isHamburgerMenuItem = true;
        mapped.isDesktopMenuItem = true;
        break;
      }
      case 'downloadableitems': {
        mapped.route = '/download-forms';
        mapped.hamburgerMenuSortOrder = 3;
        mapped.DesktopMenuSortOrder = 4;
        mapped.isHamburgerMenuItem = true;
        mapped.isDesktopMenuItem = true;
        break;
      }
      case 'contactus': {
        mapped.route = '/contact-us';
        mapped.hamburgerMenuSortOrder = 5;
        mapped.isHamburgerMenuItem = true;
        mapped.isDesktopMenuItem = false;
        break;
      }
      default:
        mapped.isHamburgerMenuItem = false;
        mapped.isDesktopMenuItem = false;
        break;
    }
    return mapped;
  })
);
